import SideBar from "../../components/sideBar";
import styles from "./customerShell.module.css";

// Customer panel page frame (sidebar + content) for the Shop Now and order history pages
const CustomerShell = ({ eyebrow, title, sub, actions, children }) => (<div className={styles.MainDivCustomer}>
  <div className={styles.Container}>
    <div className={styles.CusRow}>
      <div className={styles.CustomerSideBar}><SideBar /></div>
      <div className={styles.CustomerDeSec}>
        {title && (<div className={styles.Head}>
          <div>
            {eyebrow && <p className={styles.Eyebrow}>{eyebrow}</p>}
            <h1 className={styles.Title}>{title}</h1>
            {sub && <p className={styles.Sub}>{sub}</p>}
          </div>
          {actions && <div className={styles.Actions}>{actions}</div>}
        </div>)}
        {children}
      </div>
    </div>
  </div>
</div>);

export default CustomerShell;
